import { useEffect, useState } from 'react'

/**
 * `value`, but only after it has stopped changing for `delayMs`. Feed a search box's text through
 * this before it reaches a query key, so typing "trail" is one request instead of five.
 */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
